import { MultipleItemResponse, fetchContent } from './fetchContent'
import { RolexStorePageV72024 } from './models/RolexStorePageV72024'

type Path = {
  locale: string
  params: {
    sid: string
  }
}

export const getCatchAllRolexStorePaths = async (preview?: boolean) => {
  let paths: Path[] = []

  const languages = ['nl', 'en', 'sg', 'de']
  for (const language of languages) {
    const lang = ['sg', 'de'].includes(language) ? 'en' : language
    const response: MultipleItemResponse<RolexStorePageV72024> = await fetchContent({
      path: '',
      preview,
      params: {
        elements: ['url_slug'],
        'system.type[in]': ['rolex_store_page_v7_2024'],
        language: lang,
      },
    })

    response.items.forEach((item) => {
      if (item.system.language === lang && item.elements.url_slug.value.length) {
        paths.push({
          locale: lang,
          params: {
            sid: item.elements.url_slug.value,
          },
        })
      }
    })
  }

  return paths
}
